import classNames from 'classnames';
import React from 'react';
import './Card.scss';
import ICardProps from './CardProps';

const Card = ({ type, leftBorderType, children, onClick, className }: ICardProps) => {
  const classes = classNames(
    {
      'card': true,
      [`card-${type}`]: true,
      'card-left-border-primary': leftBorderType ? (leftBorderType === 'primary' ? true : false) : false,
      'card-left-border-danger': leftBorderType ? (leftBorderType === 'danger' ? true : false) : false,
    },
    className
  );

  function handleClick(event: React.MouseEvent) {
    if (onClick) {
      onClick(event);
    }
  }

  return (
    <div className={classes} onClick={handleClick}>
      {children}
    </div>
  );
};

Card.defaultProps = {
  type: 'shadow',
  leftBorderType: undefined,
};

export default Card;
